/**
 * Card component - Container for displaying related content.
 * NOW THEME-AWARE
 */

import React, { useMemo } from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { useTheme } from '../../contexts/ThemeContext';

interface CardProps {
  children: React.ReactNode;
  style?: ViewStyle;
  padding?: number;
}

export function Card({ children, style, padding = 16 }: CardProps) {
  const { theme } = useTheme();
  const styles = useMemo(() => createThemedStyles(theme), [theme]);

  return <View style={[styles.card, { padding }, style]}>{children}</View>;
}

/**
 * Create themed styles dynamically
 */
function createThemedStyles(theme: any) {
  return StyleSheet.create({
    card: {
      backgroundColor: theme.colors.surface,
      borderRadius: theme.radii.md,
      borderWidth: theme.id === 'bauhaus' ? 2 : 0,
      borderColor: theme.colors.border,
      shadowColor: theme.id === 'bauhaus' ? '#000' : theme.colors.primary,
      shadowOffset: theme.id === 'bauhaus' ? { width: 8, height: 8 } : { width: 0, height: 0 },
      shadowOpacity: theme.id === 'bauhaus' ? 1 : 0.3,
      shadowRadius: theme.id === 'bauhaus' ? 0 : 8,
      elevation: 3,
      marginBottom: 12,
      overflow: 'hidden',
    },
  });
}
